// HeyWebCMS/js/api.js

const isLocal =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

const cfg = window.HEYWEB && typeof window.HEYWEB === "object" ? window.HEYWEB : {};

export const API_BASE_URL =
    cfg.BACKEND_BASE_URL ||
    (isLocal ? "http://localhost:3000" : "https://siteeiro-api.onrender.com");

export const TEMPLATES_BASE_URL =
    cfg.TEMPLATES_BASE_URL ||
    (isLocal ? "http://localhost:8080" : window.location.origin);

const normalizePath = (p) => {
    const s = String(p || "").trim();
    if (!s) return "/";
    return s.startsWith("/") ? s : `/${s}`;
};

const stripTrailingSlashes = (s) => String(s || "").replace(/\/+$/, "");

/**
 * Utilitário para chamadas à API Rust
 */
export const apiFetch = async (endpoint, options = {}) => {
    const token = localStorage.getItem("heyweb_token");
    const method = String(options.method || "GET").toUpperCase();

    let body = options.body;
    if (body && typeof body === 'object' && !(body instanceof FormData)) {
        body = JSON.stringify(body);
    }

    const defaultHeaders = {
        Accept: "application/json",
        ...(body && !(options.body instanceof FormData) ? { "Content-Type": "application/json" } : {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };

    const url = `${stripTrailingSlashes(API_BASE_URL)}/api${normalizePath(endpoint)}`;

    try {
        const response = await fetch(url, {
            ...options,
            method,
            body,
            headers: { ...defaultHeaders, ...(options.headers || {}) },
        });

        if (response.status === 401) {
            localStorage.removeItem("heyweb_token");
            window.location.hash = "#login";
        }
        return response;
    } catch (error) {
        console.error("🚨 Erro apiFetch:", error);
        throw error;
    }
};

/**
 * Fetch para o Eleventy (templates.json, imagens, etc)
 */
export const staticFetch = async (pathOrUrl, options = {}) => {
    const raw = String(pathOrUrl || "").trim();
    const isAbsolute = /^https?:\/\//i.test(raw);

    // Via Proxy no dev (5173 -> 8080) ou URL direta em prod
    const url = isAbsolute ? raw : (isLocal ? normalizePath(raw) : `${stripTrailingSlashes(TEMPLATES_BASE_URL)}${normalizePath(raw)}`);

    try {
        return await fetch(url, { ...options, method: "GET" });
    } catch (error) {
        console.error("🚨 Erro staticFetch:", error);
        throw error;
    }
};

// ============================================================================
// FUNÇÕES EXPORTADAS PARA O DASHBOARD E TEMPLATES
// ============================================================================

export async function getMySites() {
    const resp = await apiFetch("/my-sites", { method: "GET" });
    if (!resp.ok) return [];
    return await resp.json();
}


// ✅ ESTA É A FUNÇÃO QUE ESTAVA FALTANDO NO SEU ERRO
export async function deleteSite(sitePath) {
    const resp = await apiFetch(`/my-sites/${encodeURIComponent(sitePath)}`, { method: "DELETE" });
    if (!resp.ok) {
        const raw = await resp.text();
        let message = "";

        try {
            const parsed = raw ? JSON.parse(raw) : null;
            message = parsed?.stderr || parsed?.error || parsed?.message || "";
        } catch {
            message = raw || "";
        }


        throw new Error(message || `Nao foi possivel eliminar o site. HTTP ${resp.status}`);
    }

    if (resp.status === 204) {
        return { ok: true, deleted_site: true, deleted_pages: 0, r2_deleted: true, warnings: [] };
    }

    return await resp.json();
}

export async function publishSite(sitePath) {
    const resp = await apiFetch(`/my-sites/${encodeURIComponent(sitePath)}/publish`, { method: "POST" });
    if (!resp.ok) {
        const raw = await resp.text();
        let message = "";

        try {
            const parsed = raw ? JSON.parse(raw) : null;
            message = parsed?.message || parsed?.error || "";
        } catch {
            message = raw || "";
        }

        if (resp.status === 404) {
            throw new Error("O endpoint de publicacao nao existe no backend em execucao. Reinicia o siteeiro-backend para carregar a rota nova.");
        }

        if (resp.status === 401) {
            throw new Error("A tua sessao expirou. Inicia sessao novamente e volta a tentar.");
        }

        throw new Error(message || `Nao foi possivel publicar o site. HTTP ${resp.status}`);
    }
    return await resp.json();
}

export async function getTemplatePresets(tplData) {
    if (!tplData || !tplData.categoria || !tplData.vertical) return null;
    const path = `/templates-assets/${tplData.categoria}/${tplData.vertical}/presets.json`;
    try {
        const resp = await staticFetch(path);
        if (!resp.ok) return null;
        return await resp.json();
    } catch (e) {
        return null;
    }
}
